"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableField = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_sortable_hoc_1 = require("react-sortable-hoc");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const react_window_1 = require("react-window");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const table_field_styles_1 = require("./table-field-styles");
const table_field_context_1 = require("./table-field-context");
const table_field_hook_1 = require("./table-field-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
exports.TableField = react_1.forwardRef(function TableField(options, ref) {
    const classes = table_field_styles_1.useStyles();
    const { props, selectedIndex, setSelectedIndex, context, formDialogRef, removeDialogRef, swapRows, } = table_field_hook_1.useTableField(options);
    const { RowComponent, showToolbar, ToolbarComponent, HeaderComponent, FormFieldsComponent, DialogComponent, RemoveDialogComponent, } = props;
    /**
     * Reference to VariableSizeList
     */
    const listRef = react_1.useRef(null);
    const SortableFixedSizeList = react_1.useMemo(() => react_sortable_hoc_1.SortableContainer((props) => (react_1.default.createElement(react_window_1.VariableSizeList, Object.assign({}, props, { ref: listRef })))), []);
    /**
     * Map of each mounted item height.
     */
    const itemHeightMap = react_1.useRef({});
    const maxHeight = props.maxRows * 30;
    const minWidth = props.columns
        .map((col) => col.width)
        .reduce((a, b) => a + b, 0);
    const setItemHeight = event_callback_hook_1.useEventCallback((index, size) => {
        itemHeightMap.current = { ...itemHeightMap.current, [index]: size };
    });
    const getItemHeight = event_callback_hook_1.useEventCallback((index) => itemHeightMap.current[index] || 30);
    /**
     * Height of VariableSizeList, dynamically changed between `defaultRowHeight` and `maxListHeight`.
     */
    const [listHeight, setListHeight] = react_1.useState(30);
    const computeListHeight = event_callback_hook_1.useEventCallback((itemIndex, itemHeight) => {
        if (itemIndex !== undefined &&
            itemHeight !== undefined &&
            listRef.current) {
            setItemHeight(itemIndex, itemHeight);
            listRef.current.resetAfterIndex(itemIndex);
        }
        else {
            itemHeightMap.current = {};
        }
        let newListHeight = 0;
        for (const key in itemHeightMap.current) {
            newListHeight += itemHeightMap.current[key];
        }
        if (newListHeight > maxHeight) {
            newListHeight = maxHeight;
        }
        setListHeight(newListHeight);
    });
    react_1.useEffect(() => {
        computeListHeight();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.value.length]);
    const SortableItem = react_sortable_hoc_1.SortableElement((props) => {
        const { index, style, data } = props.nestedProps;
        const { value, selectedIndex } = data;
        return (react_1.default.createElement("div", { style: { ...style } },
            react_1.default.createElement(RowComponent, { value: value[index], index: index, selected: selectedIndex === index, ref: (item) => {
                    if (item &&
                        item.clientHeight + 1 !== itemHeightMap.current[index]) {
                        computeListHeight(index, item.clientHeight + 1);
                    }
                } })));
    });
    const renderItem = react_1.useCallback((props) => {
        const { index } = props;
        // we need to post the props inside, so the index prop is not discarted by 'react-sortable-hoc'
        return react_1.default.createElement(SortableItem, { index: index, nestedProps: props });
    }, []);
    react_1.useImperativeHandle(ref, () => ({
        selectedIndex,
        setSelectedIndex: (index) => {
            setSelectedIndex(index);
        },
    }), [selectedIndex, setSelectedIndex]);
    // we need real width of the header for the react-window wrapper
    const [measureRef, { width }] = react_use_measure_1.default();
    return (react_1.default.createElement(table_field_context_1.TableFieldContext.Provider, { value: context },
        react_1.default.createElement("div", { className: clsx_1.default(classes.componentWrapper, {
                [classes.noMinHeigth]: options.noMinHeigth,
            }), style: {
                width: options.noMinHeigth ? minWidth : 'auto',
            } },
            showToolbar && (react_1.default.createElement(ToolbarComponent, { selectedIndex: selectedIndex, setSelectedIndex: setSelectedIndex })),
            react_1.default.createElement(Grid_1.default, { container: true, className: clsx_1.default(classes.grid, {
                    [classes.noMinHeigth]: options.noMinHeigth,
                }) },
                react_1.default.createElement("div", { className: classes.tableWrapper },
                    react_1.default.createElement(HeaderComponent, { ref: measureRef }),
                    react_1.default.createElement("div", { className: clsx_1.default(classes.dataWrapper, {
                            [classes.noMinHeigth]: options.noMinHeigth,
                        }), style: { maxHeight, width } },
                        react_1.default.createElement(SortableFixedSizeList, { useDragHandle: true, onSortEnd: swapRows, height: Math.min(maxHeight, listHeight), width: "100%", style: {
                                overflowX: 'hidden',
                                overflowY: 'auto',
                            }, itemSize: getItemHeight, itemData: {
                                value: context.value,
                                selectedIndex,
                            }, itemCount: context.value.length }, renderItem)))),
            FormFieldsComponent !== undefined && (react_1.default.createElement(DialogComponent, { ref: formDialogRef, index: selectedIndex, FormFieldsComponent: FormFieldsComponent, value: selectedIndex !== undefined ? context.value[selectedIndex] : null })),
            react_1.default.createElement(RemoveDialogComponent, { ref: removeDialogRef, index: selectedIndex }))));
});
//# sourceMappingURL=table-field.js.map